import _fillInstanceProperty from "@babel/runtime-corejs3/core-js/instance/fill";
import { map as _$ma, createUnknownComponentVNode as _$cc, createElementVNode as _$ce, className as _$cn } from 'intact-vue';
import { SkeletonItem } from './item';
import { makeStyles, kls } from './styles';
var _$tmp0 = {
  'type': 'avator'
};
export default function ($props, $blocks, $__proto__) {
  var _context, _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    rows = _this$get.rows,
    avator = _this$get.avator,
    animated = _this$get.animated,
    children = _this$get.children,
    loading = _this$get.loading,
    size = _this$get.size;
  var k = this.config.k;
  var targetRows = typeof rows !== 'number' ? 3 : rows < 1 ? 1 : parseInt(rows);
  var skeletonList = _fillInstanceProperty(_context = Array(targetRows + 2)).call(_context);
  var skeletonItems = _$ma(skeletonList, function ($value, $key) {
    return _$cc(SkeletonItem);
  }, $this);
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-skeleton"] = true, _classNameObj[k + "-animated"] = animated, _classNameObj[makeStyles(k, size)] = true, _classNameObj);
  return loading ? _$ce(2, 'div', children ? _$ce(2, 'div', children, 0) : avator ? _$ce(2, 'div', [_$cc(SkeletonItem, _$tmp0), _$ce(2, 'div', skeletonItems, 0, _$cn(k + "-skeleton-items"))], 4, _$cn(kls('avator-box', k))) : _$ce(2, 'div', skeletonItems, 0, _$cn(k + "-skeleton-items")), 2, _$cn(classNameObj)) : undefined;
}
;